import axios from "axios";
import {
  getAccessToken,
  getExpiresIn,
  getIdToken,
  redirectToRefreshToken,
} from "../storage/SessionStorageService";
import { EnhancedStore } from "@reduxjs/toolkit";
import { BrowserHistory } from "@remix-run/router";
import { APIConstants } from "../../constants/ApiConstants";
import Bugsnag from "@bugsnag/js";
import { getDomainUrl } from "../../components/forms/utility";
import dayjs from "dayjs";

export const startSession = () => {
  const startTime = dayjs().toISOString();
  localStorage.setItem("sessionStartTime", startTime);
};

export const getSessionDuration = () => {
  const storedStartTime = localStorage.getItem("sessionStartTime");
  if (storedStartTime) {
    const sessionStartTime = dayjs(storedStartTime);
    const currentSessionTime = dayjs().diff(sessionStartTime, "second");
    localStorage.setItem("sessionTime", currentSessionTime.toString());
    return currentSessionTime;
  }
  return 0;
};

export const stopSession = () => {
  localStorage.removeItem("sessionStartTime");
  localStorage.setItem("sessionTime", "0");
};

export default {
  setupInterceptors: (store: EnhancedStore, history: BrowserHistory) => {
    axios.interceptors.request.use(
      function (config) {
        const token = getIdToken();
        const AccessToken = getAccessToken();
        const domainName = getDomainUrl();
        const ExpiresIn = getExpiresIn();

      

        if (
          config.url?.includes(
            process.env.REACT_APP_API_URL + APIConstants.addPhysicalVoucherBulk
          ) ||
          config.url?.includes(
            process.env.REACT_APP_API_URL + APIConstants.finance_reports
          ) ||
          config.url?.includes(
            process.env.REACT_APP_API_URL + APIConstants.bulkUpload
          )
        ) {
          config.headers["Content-Type"] = "multipart/form-data";
        } else {
          config.headers["Content-Type"] = "application/json";
    
        }
        config.headers["Access-Control-Allow-Origin"] = "*";
        config.headers["implementation-id"] = "sg-suntec-city";

     

        config.headers["Token"] = AccessToken;
        config.headers["Domain"] = domainName;
        if (token) {
          config.headers["Authorization"] = "Bearer " + token;
        }


      
        getSessionDuration();

        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (response) => {
        getSessionDuration();
        return response;
      },
      async (error) => {
        Bugsnag.notify(new Error(error));
        const originalRequest = error.config;
        if (error?.response?.status === 401) {
          originalRequest.retry = true;
          redirectToRefreshToken();
        }

        getSessionDuration();

        return Promise.reject(error);
      }
    );
  },
};
